export default __webpack_public_path__ + "static/iCARE-Risk-factors-edc8823a60764fc2c513494fb3d16b39.png";